import React from "react";

const QuestionCard = ({ data }) => {
  if (!data?.Question) return null;
  return (
    <div className="nav-card question-card">
      <div className="question-text">{data.Question}</div>
    </div>
  );
};

export default QuestionCard;
